<template>
  <wsp-modal>
    <v-card class="pb-5"
            flat>
      <v-card-title class="pa-0">
        <v-toolbar class="primary"
                   dark
                   dense
                   flat>
          <v-toolbar-title>
            {{ $t('plates.deletePlate.title', { code: plate.code }) }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon
                 @click="visible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text v-html="$t('plates.detelePlate.message')">
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="capitalize primary--text"
               flat
               @click="visible = false">
          {{ $t('global.button.cancel')}}</v-btn>

        <v-btn color="accent"
               class="capitalize white--text mr-2"
               outline
               round
               @click="deletePlate">
          {{ $t('global.button.agree')}}</v-btn>
      </v-card-actions>
    </v-card>
  </wsp-modal>
</template>

<script>
import WspModal from '@/components/commons/WspModal';
import plateService from '@/services/plateService';
import manageErrorService from '@/services/manageErrorService';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'DeletePlate',
  components: {
    [WspModal.name]: WspModal
  },
  props: {
    plate: {
      type: Object,
      required: true
    }
  },
  watch: {
    visible: function(value) {
      if (!value) {
        this.$emit('on-close', {});
      }
    }
  },
  data() {
    return {
      visible: true
    };
  },
  methods: {
    async deletePlate() {
      let params = {
        id: this.plate.id
      };
      let results = await plateService.delete(params)

      if (results.error) {
        manageErrorService.handle(results.data);
        this.showContent = true
        return;
      }

      this.visible = false
      this.$emit('on-success', {})

      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: this.$i18n.t('plates.deletePlate.toast.success'),
        type: 'info',
        doNotTranslate: true
      });
    }
  }
};
</script>
